import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import WalmartAbstractFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAbstractFilterRenderer';
import { FilterLineForEmailEventFilter } from 'flow-doctor-lib/utils/filterRenderUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartEmailEventFilterRenderer = ({
  filter
}) => {
  return /*#__PURE__*/_jsx(WalmartAbstractFilterRenderer, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.filters.emailEvent.label"
    }),
    filterLine: /*#__PURE__*/_jsx(FilterLineForEmailEventFilter, {
      filter: filter
    })
  });
};
export default WalmartEmailEventFilterRenderer;